/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fancy_Tame_Otter_FilterInputs */

const fr_fancy_tame_otter_filter = /** @type {(inputs: Fancy_Tame_Otter_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de programme:`)
};

/**

* @param {Fancy_Tame_Otter_FilterInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fancy_tame_otter_filter = /** @type {((inputs?: Fancy_Tame_Otter_FilterInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fancy_Tame_Otter_FilterInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fancy_tame_otter_filter(inputs)
});